<template>
    <div class="tint-full-screen solid-tint-black-black80 pos-fix solid-tint-black-black80 z-index-10" v-show="active"></div>
</template>

<script>
    export default {
        name : 'TintFullScreen',
        props : {
            active : Boolean
        },
        data : function () {
            return {}
        },
        methods : {

        }
    }
</script>

<style>
    .tint-full-screen{
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>